import { useEffect, useState } from 'react';
import { de_AT_bvReactClientDefaultConfig } from './bvdReactAppConfigs/de-AT/bvReactClientDefaultConfig';
import { de_DE_bvReactClientDefaultConfig } from './bvdReactAppConfigs/de-DE/bvReactClientDefaultConfig';
import { en_US_bvReactClientDefaultConfig } from './bvdReactAppConfigs/en-US/bvReactClientDefaultConfig';
import { addUserInfosToGTM, BVTracking } from './customeClientJSCode';

const getBvReactClientConfigByLocal = (locale: string) => {
  if (locale === 'de-AT') {
    return de_AT_bvReactClientDefaultConfig;
  } else if (locale === 'en-US') {
    return en_US_bvReactClientDefaultConfig;
  } else {
    return de_DE_bvReactClientDefaultConfig;
  }
};

const stringifyBvReactClientConfig = (bvReactClientConfig: object) => {
  const bvReactClientConfigString = JSON.stringify(bvReactClientConfig);
  // addUserInfosToGTM & trackingFunction are defined in _document.tsx
  return `${BVTracking} ${addUserInfosToGTM} window.bvAppConfig = {
    ${bvReactClientConfigString.substring(
      1,
      bvReactClientConfigString.length - 1
    )},
    initListeners: [],
    loginListeners: [addUserInfosToGTM],
    tracker: trackingFunction,
  };`;
};

export const useBvdReactClient = (
  locale: string,
  bvReactClientConfigOverride?: object
) => {
  const [init, setInit] = useState(false);
  useEffect(() => {
    const bvAppConfig = {
      ...getBvReactClientConfigByLocal(locale),
      ...bvReactClientConfigOverride,
    };
    const bvReactClientConfigString = stringifyBvReactClientConfig(bvAppConfig);
    if (bvAppConfig) {
      const script = document.createElement('script');
      script.textContent = bvReactClientConfigString;
      document.body.appendChild(script);
      setInit(true);
    }
  }, [bvReactClientConfigOverride, locale]);

  useEffect(() => {
    const runtimeBundle = document.createElement('script');
    runtimeBundle.src =
      `${process.env.NEXT_PUBLIC_BV_REACT_CLIENT_HOST}/runtime.bundle.js` || '';
    runtimeBundle.async = true;
    document.body.appendChild(runtimeBundle);
    const mainBundle = document.createElement('script');
    mainBundle.src =
      `${process.env.NEXT_PUBLIC_BV_REACT_CLIENT_HOST}/main.bundle.js` || '';
    mainBundle.async = true;
    document.body.appendChild(mainBundle);
  }, []);
};
